
import XButton from 'vux/src/components/x-button/index.vue'

import { mapGetters } from 'vuex';
import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
XButton,
},
mounted() {
},
activated() {
},
watch: {
},
data() {
return {

};
},
computed: {
...mapGetters([
'isLower',
'isUpper',
]),
companyStatus() {
return this.$store.state.companyStatus;
},
},
methods: {
save() {
this.$router.push({
name: 'mineIndex',
})
},
},
};
